module.exports = __webpack_public_path__ + "img/objective.ab2d961e.svg";